import React from "react";
import { forwardRef } from "react";

const MFElssReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      hasVerticalScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <table className="table width-99">
        <thead>
          <tr>
            <th className={clientDashboard ? "text-center" : ""}>
              <span className="wrap-th">
                <span>Sr No.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>NAV Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Scheme Name</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Folio Number</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Units</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Amount</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Category</span>
              </span>
            </th>
            {hasVerticalScroll && <th className="scrollerthead"></th>}
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.navDate}</td>
                  <td>{item?.schemeName || "-"}</td>
                  <td>{item?.folioNo || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.amount || "-"}</td>
                  <td>{item?.category || "-"}</td>
                </tr>
              );
            })}
          {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
        </tbody>
      </table>
    );
  }
);

export default MFElssReportTable;
